<template>
    <div>
<h1>
    La Pagina no existe
</h1>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>